export const getUpcomingPageRequest = (view) => {
  const nextPageUrl = view && view.next_page_url;
  return nextPageUrl ? { next_page_url: nextPageUrl } : null;
};

export const mergeUpcomingAppointmentPage = (current, next) => {
  const currentPage = Number(current && current.current_page);
  const nextPage = Number(next && next.current_page);

  if (
    currentPage > 0 &&
    nextPage > currentPage &&
    Array.isArray(current && current.data) &&
    Array.isArray(next && next.data)
  ) {
    return { ...next, data: [...current.data, ...next.data] };
  }

  return next;
};
